import { useCallback, useState } from 'react';

/**
 * @callback onChangeCb
 * @param {Moment} day
 */

/**
 * Functions for calendar
 * @param {Moment} day
 * @returns {{calendar:[],getWeek: (function(*): *[])}}
 */
export function useWeekCalcs(day) {
  const [calendar, setCalendar] = useState([]);

  const getWeek = useCallback(() => {
    const newCalendar = [];
    const rangeStart = day.clone().subtract(1, 'day');
    const rangeEnd = day.clone().add(13, 'day');

    while (rangeStart.isBefore(rangeEnd)) {
      rangeStart.add(1, 'day');
      newCalendar.push(rangeStart.clone());
    }
    setCalendar(newCalendar);
  }, [day]);

  return { calendar, getWeek };
}

export class useWeekCals {}
